import React, {Fragment} from "react";
import BoxEditor from "../../BoxEditor";
import List from './List';
import Other from "./Other";
import Source from "./Inventory/Source";
import Save from "./Buttons/Save";
import New from "./Buttons/New";
import ProductPicker from "./Inventory/ProductPicker";
import Items from "./Inventory/Items";
import Progress from "./Inventory/Progress";
import DiffView from "./Inventory/DiffView";
import Collapse from "../../../layout/Collapse";
import debounce from "lodash-es/debounce";
import {CurrencyFormatter, ProductSelect} from "../../../../utils/formatters";
import classNames from "classnames";
import AccountDate from "./Invoice/Dates/AccountDate";
import Comment from "./Comment";

class InventoryForm extends React.Component {

    requests = {};

    constructor(props) {
        super(props);
        this.state = {
            requests: {}
        }
        this.refreshBackground = debounce(() => {
            if (this.props.check) {
                this.progress && this.progress.loadProgress();
                this.diff && this.diff.refreshBackground();
            }
            this.items && this.items.refreshBackground();
        }, 300);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.check === false && this.props.check === true) {
            this.progress && this.progress.loadProgress();
            this.diff && this.diff.refreshBackground();
        }
    }

    addPickedItem = async (picked) => {
        const item = {};
        item.component_id = picked.id;
        item.component_type = "product";
        item.vat = picked.vat;
        item.listprice = picked.listprice;
        item.saleprice = new Date().getTime();
        item.qty = picked.qty;
        const componentProps = {...this.props};
        const {parent} = componentProps;
        const requestId = (new Date()).getTime();
        this.setState({requests: {...this.state.requests, [requestId]: picked}}, () => {
            this.requests[requestId] = async () => {
                try {
                    await parent.onSourceItemUpdate(item, JSON.parse(JSON.stringify(item)), null);
                    const requests = {...this.state.requests};
                    delete requests[requestId];
                    this.setState({requests});
                } catch (e) {
                    const requests = {...this.state.requests};
                    delete requests[requestId];
                    this.setState({requests});
                    throw e;
                }
                this.refreshBackground();
            }
            this.requests[requestId]();
        });
    }

    render() {
        const componentProps = {...this.props};
        const {props, state, parent} = componentProps;
        const {hidden, labels, actionButtons} = props;
        const Editor = props.editor || BoxEditor;
        return <Fragment>
            <List boxid={props.componentEditor + "ListBox"} {...componentProps} collapsed={undefined} />
            <Editor
                theme="default"
                header={<Fragment><b>{this.props.values.label}</b>{this.props.values.saved + "" !== "1" && <span className="label label-danger">Piszkozat</span> }</Fragment>}
                body={
                    props.values.id && <form onSubmit={props.handleSubmit}>
                        <div className="row">
                            <div className={classNames({"col-md-6": this.props.user.hasPermission("change_inventory"), "col-md-12": !this.props.user.hasPermission("change_inventory")})}>
                                <Source {...this.props} />
                            </div>
                            {this.props.user.hasPermission("change_inventory") &&
                            <AccountDate
                                col="6"
                                {...componentProps}
                                isClearable={true}
                            />
                            }
                        </div>
                        {props.values.source && <Fragment>
                            {!this.props.user.hasPermission("change_inventory") &&
                            <Fragment>
                                <div className="form-group">
                                    <ProductPicker {...this.props} addPickedItem={this.addPickedItem} async={true}/>
                                </div>
                                {!!Object.keys(this.state.requests).length && <div className="form-group">
                                    <label className="control-label">Hozzáadás folyamatban</label>
                                    <div className="p-datatable p-component p-small-table table table-hover">
                                        <div className="p-datatable-wrapper">
                                            <table>
                                                <thead className="p-datatable-thead">
                                                <tr>
                                                    <th>Megnevezés</th>
                                                    <th>Vonalkód</th>
                                                    <th>Sku</th>
                                                    <th>Lista ár</th>
                                                </tr>
                                                </thead>
                                                <tbody className="p-datatable-tbody">
                                                {Object.keys(this.state.requests).map((requestId, idx) => {
                                                    return <tr key={idx}>
                                                        <td style={{
                                                            padding: "5px",
                                                            fontSize: "1.2rem"
                                                        }}>{this.state.requests[requestId].displayname}</td>
                                                        <td style={{
                                                            padding: "5px",
                                                            fontSize: "1.2rem"
                                                        }}>{this.state.requests[requestId].barcode}</td>
                                                        <td style={{
                                                            padding: "5px",
                                                            fontSize: "1.2rem"
                                                        }}>{this.state.requests[requestId].sku}</td>
                                                        <td style={{
                                                            padding: "5px",
                                                            fontSize: "1.2rem"
                                                        }}>{CurrencyFormatter(this.state.requests[requestId].listprice)}</td>
                                                    </tr>;
                                                })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>}
                                <div className="form-group">
                                    <label className="control-label">Tételek</label>
                                    <Items ref={(items) => this.items = items} {...componentProps} removedItem={() => {
                                        this.refreshBackground();
                                    }}/>
                                </div>
                            </Fragment>
                            }
                            <Other tag={Fragment} {...{...componentProps, props: {...componentProps.props, getProps: (field) => {
                                        const props = {...componentProps.props.getProps(field)};
                                        if (this.props.check) {
                                            props.disabled = true;
                                        }
                                        return props;
                                    }}}} />
                            <Collapse collapsed={!!this.props.check || this.props.user.hasPermission("change_inventory")}>
                                <div>
                                    <DiffView
                                        ref={(diff) => this.diff = diff}
                                        {...componentProps}
                                        check={this.props.check}
                                        swapCheck={this.props.swapCheck}
                                    />
                                    {!this.props.user.hasPermission("change_inventory") ? <Progress
                                        ref={(progress) => this.progress = progress}
                                        {...componentProps}
                                        id={props.values.id}
                                        source={props.values.source.id}
                                        partner={props.values.source.partner.partner_id}
                                        accountdate={props.values.accountdate}
                                    /> : <Comment {...componentProps} />}
                                </div>
                            </Collapse>
                        </Fragment>}
                    </form>
                }
                footer={<Fragment>
                    {actionButtons}
                    <Save {...componentProps} />
                    <New {...componentProps} />
                </Fragment>}
            />
        </Fragment>;
    }
}


export default InventoryForm;